<template>
  <table class="mailTable" v-if="s_showByRow">
    <tr v-for="index in rowCount" :key="index">
      <td class="column">{{ tableData[index * 2 - 2].key }}</td>
      <td class="row" v-html="tableData[index * 2 - 2].value"></td>
      <td class="column">
        {{
          tableData[index * 2 - 1] !== undefined
            ? tableData[index * 2 - 1].key
            : ""
        }}
      </td>
      <td
        class="row"
        v-html="
          tableData[index * 2 - 1] !== undefined
            ? tableData[index * 2 - 1].value
            : ''
        "
      ></td>
    </tr>
  </table>
  <table class="mailTable" v-else>
    <tr v-for="index in rowCountTwo" :key="index">
      <td class="column">{{ tableData[index - 1].key }}</td>
      <td class="row" v-html="tableData[index - 1].value"></td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "mailTable",
  data() {
    return {
      s_showByRow: false,
    };
  },
  props: ["tableData", "showByRow"],
  computed: {
    rowCount: function () {
      return Math.ceil(this.tableData.length / 2);
    },
    rowCountTwo: function () {
      return Math.ceil(this.tableData.length);
    },
  },
  created() {
    if (this.showByRow !== undefined) {
      this.s_showByRow = this.showByRow;
    }
  },
};
</script>

<style lang="less" scoped>
　　.mailTable,
.mailTable tr,
.mailTable tr td {
  border: 1px solid #606266;
}
　　.mailTable {
  font-size: 14px;
  color: #606266;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
}
　　.mailTable tr td {
  border: 1px solid #606266;
  height: 40px;
  box-sizing: border-box;
  line-height: 20px;
  padding: 10px;
}
　.column {
  text-align: center;
  background-color: #ebe6db;
  color: #393c3e;
  width: 150px;
}
.row {
  color: #393c3e;
  text-align: left;
  word-break: break-all;
  word-wrap: break-word;
}
</style>